import { render, staticRenderFns } from "./serviceDepartment.vue?vue&type=template&id=6ba7bf43&scoped=true&"
import script from "./serviceDepartment.vue?vue&type=script&lang=js&"
export * from "./serviceDepartment.vue?vue&type=script&lang=js&"
import style0 from "./serviceDepartment.vue?vue&type=style&index=0&id=6ba7bf43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7bf43",
  null
  
)

export default component.exports